import $ from "../node_modules/dabbyjs/src/core/core.js";
import "../node_modules/dabbyjs/src/attributes/data/data.js";
import "./swgfl/javascript/accessibility.js";
import security from "./swgfl/security/javascript/all.js";
import cms from "./swgfl/cms/javascript/cms.js";
import forms from "./swgfl/forms/javascript/forms.js";
import cookies from "./swgfl/cookies/javascript/cookies.js";
import faqs from "./swgfl/faqs/javascript/faqs.js";
import chatbot from "./swgfl/chatbot/javascript/chatbot.js";
import copy from "./swgfl/javascript/copy.js";
import gtm from "./swgfl/javascript/google-tag-manager.js";
import "../node_modules/dabbyjs/src/attributes/data/data.js";
import map from "./swgfl/javascript/map.js";
import survey from "./website/javascript/survey.js";
import "./swgfl/report/javascript/report.js";

$(() => {
	cookies($(".cookies"));
	security();
	cms($("#form-cms"));
	forms();
	faqs($(".faqs"));
	chatbot($(".chatbot[data-chatbot]"));
	copy($('[data-copy]'));
	survey($(".survey__switch"));
	map($("[data-map]"));
	gtm($("html").data("gtm"));
});
